import { useEffect, useState } from 'react';

import { MOCK_AD_SECONDS } from './mock-playback';

interface RewardedAdPlaybackProps {
  reward: number;
  /** false — показ имитирует заглушка, и об этом нужно сказать прямо. */
  realAd: boolean;
  finishing: boolean;
  onFinish: () => void;
  onCancel: () => void;
}

/**
 * Показ рекламы.
 *
 * Пока подключён mock-провайдер, «показ» — это обратный отсчёт: настоящая
 * сеть отрисует ролик сама и сообщит о завершении. Важно здесь другое и
 * общее для всех провайдеров: награду можно попросить только после конца
 * показа, а «Закрыть» означает, что показа не было.
 */
export function RewardedAdPlayback({
  reward,
  realAd,
  finishing,
  onFinish,
  onCancel,
}: RewardedAdPlaybackProps) {
  const [secondsLeft, setSecondsLeft] = useState(MOCK_AD_SECONDS);

  useEffect(() => {
    if (secondsLeft <= 0) {
      return;
    }

    const timer = setInterval(() => {
      setSecondsLeft((left) => Math.max(0, left - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [secondsLeft]);

  const watched = secondsLeft <= 0;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Показ рекламы"
      className="fixed inset-0 z-50 flex items-center justify-center bg-scrim/80 px-6"
    >
      <div className="w-full max-w-sm rounded-2xl border border-border bg-surface p-6">
        <p className="text-lg font-semibold text-text">Реклама</p>

        {!realAd && (
          <p className="mt-2 text-sm text-text-2">
            Реальная реклама не подключена — это заглушка показа для разработки.
          </p>
        )}

        <p className="mt-4 text-sm text-text-2" aria-live="polite">
          {watched ? 'Показ завершён.' : `Осталось ${secondsLeft} с`}
        </p>

        <div className="mt-6 flex gap-3">
          <button
            type="button"
            onClick={onFinish}
            disabled={!watched || finishing}
            className="btn btn-primary flex-1 px-4 py-3 text-sm"
          >
            {finishing ? 'Начисляем…' : `Получить награду: +${reward}`}
          </button>
          <button
            type="button"
            onClick={onCancel}
            disabled={finishing}
            className="btn btn-secondary px-4 py-3 text-sm"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  );
}
